const toCssVars = (varName, value) => {
  const isObject = typeof value === 'object' && !Array.isArray(value);

  if (!isObject) {
    return `${varName}: ${value};`;
  }

  return Object.entries(value)
    .reduce((acc, [propName, propValue]) => {
      const nextVarName = `${varName}-${propName}`;
      return acc + toCssVars(nextVarName, propValue);
    }, '');
};

export default toCssVars;
